import React, { RefObject } from "react";
import { RouteComponentProps } from "react-router";
import { request, handleValidationErrors } from "../helpers/utilities";
import { Spin, message } from "antd";
import Card from "../components/Card";
import { AxiosResponse } from "axios";

import BaseForm from "../components/Form/BaseForm";
import { FormFieldConfig, APIError } from "../helpers/shared-interfaces";
import { FormInstance } from "antd/lib/form/Form";
import * as Sentry from "@sentry/browser";
import { generateDisplayErrorMessage } from "../helpers/utilities";


interface State {
  isLoading: boolean;
}

const fields: FormFieldConfig[] = [
  {
    name: "name",
    label: "Name",
    inputType: "string",
    placeholder: "Enter Product Category Name ...",
    rule: "string",
    required: true,
    colConfig: {
      span: 8,
    },
  },
];

export const CREATE_PRODUCT_CATEGORY = `
  mutation CreateProductCategory($name:String!) {
    createProductCategory(name: $name){
      productCategory {
        id
        name
      }
      errors {
        property
        description
      }
    }
  }
`;

export default class CreateNewProductCategory extends React.Component<
  RouteComponentProps,
  State
> {
  reference: RefObject<FormInstance>;
  constructor(props: RouteComponentProps) {
    super(props);
    this.reference = React.createRef<FormInstance>();
    this.state = { isLoading: true };
    this.redirectToAllProductCategories =
      this.redirectToAllProductCategories.bind(this);
    this.createProductCategory = this.createProductCategory.bind(this);
  }

  async createProductCategory(): Promise<void> {
    interface Response {
      data?: {
        createProductCategory?: {
          productCategory?: {
            name: string;
          };
          errors?: APIError[];
        };
      };
      errors?: Record<string, unknown>[];
    }

    if (!this.reference.current) return;

    let data;

    try {
      data = await this.reference.current.validateFields(["name"]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    try {
      const response: AxiosResponse<Response> = await request({
        query: CREATE_PRODUCT_CATEGORY,
        variables: data,
      });

      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.createProductCategory &&
        response.data.data.createProductCategory.productCategory
      ) {
        message.success("Product Category created sucessfully");
        this.redirectToAllProductCategories();
      } else {
        message.error("Failed to create product category");
      }
    } catch (error) {
      message.error(`Failed to create product category - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    }
  }

  redirectToAllProductCategories(): void {
    this.props.history.push("/product-categories");
  }

  setRef = (ref: React.RefObject<FormInstance>): void => {
    this.reference = ref;
  };

  componentDidMount(): void {
    this.setState({ isLoading: false });
  }

  render(): JSX.Element | null {
    const { isLoading } = this.state;

    return (
      <Card header="NEW PRODUCT CATEGORY">
        <Spin spinning={isLoading}>
          <BaseForm
            size="large"
            reference={this.reference}
            layout="vertical"
            fields={[
              ...fields,
              {
                id: "createProductCategory",
                name: "createProductCategoryButton",
                inputType: "button",
                value: "Save",
                required: true,
                className: "base-button",
                elementStyle: {
                  position: "relative",
                  top: "-11px",
                },
                colConfig: {
                  span: 23,
                },
                handleClick: this.createProductCategory,
              },
            ]}
            fieldsToHide={[]}
          />
        </Spin>
      </Card>
    );
  }
}
